$(".facet-toggle").on("click", function(){
  
  $("collapsible-expandable").each(function(){
    $(this).attr("expanded", false);
    
    $(this).find(".facet-toggle").attr("expanded", false);
    $(this).find(".facet-toggle").attr("aria-expanded", false);
    
    $(this).find(".facet-content").attr("aria-expanded", false);
  });

  
  if(!$(this).hasClass("show")){
    $(this).addClass("show");
    $(this).attr("expanded", true)
    $(this).parent().parent().attr("expanded", true)
    $(this).attr("aria-expanded", true)
    $(this).next().attr("expanded", true)
  }else{
    $(this).removeClass("show");
    $(this).attr("expanded", false)
    $(this).parent().parent().attr("expanded", false)
    $(this).attr("aria-expanded", false)
    $(this).next().attr("expanded", false)
  }
  
})

$(".variants_pack .kaching-bundles__bar [type='radio']").each(function(){
  if($(this).is(":checked")){
    var currentUrl = window.location.href;
    var urlSearchParams = new URLSearchParams(new URL(currentUrl).search);

    let total_price = parseFloat($(this).val());
    
    let id = $(this).attr("id");
    if (urlSearchParams.has('selling_plan')) {
      
      let save_percent = $(`.save_${id}`).text();

      if($(`.save_${id}`).length){
        
        save_percent = save_percent.replace("SAVE ","");
        save_percent = parseInt(save_percent.replace("% OFF",""));
        
        total_price = total_price - (total_price * (10 / 100));
        
      }else{
        
        total_price = total_price - (total_price * .10);
      
      }
      

    }
    
    let quantity = $(this).siblings(".kaching-bundles__bar-container").data("quantity");
    $("input[name='quantity']").val(1);
      
    $(".form [name='id']").val(id);
    $(".form [name='id'").attr("data-productid" ,id);
    $(".form [name='product-id']").val(id);

    total_price = total_price.toFixed(2);
    
    $(".product-info-price").removeClass("d-none");
    $(".product-info-price").text("£"+total_price);
  }
});

var counterFor = 0;

function checkSubscription() {

  if ($('[name="purchaseOption"]') || counterFor == 30) {

    setTimeout(() => {
      var currentUrl = window.location.href;
      var urlSearchParams = new URLSearchParams(new URL(currentUrl).search);

      if($(".variants_pack .kaching-bundles__bar [type='radio']").length > 1){
        $(".variants_pack .kaching-bundles__bar [type='radio']").each(function(i, el){
          if($(el).is(":checked") && urlSearchParams.has('selling_plan')){
            
            var price = parseFloat($(el).val());
            save_percent = 10;
            price = (price - (price * (save_percent / 100))).toFixed(2);
        
            if($(".product-info-price")){
              $(".product-info-price").text("£"+price);
            }
            
          }
        })
      }else{
        var checkVariant = $('.rc-template__radio-group [type="radio"]');

        checkVariant.each((i, el) => {
          if($(el).is(":checked")){
            checkVariant = $(el)
          }
        })

        var price = $(checkVariant).next(".rc-radio__label").find(".price-label").text() || 0;
        if(price){
          price = price.replace("£","");
      
          if($(".product-info-price")){
            $(".product-info-price").text("£"+price);
          }
        }
        
      }
      
    }, 200)
    
    clearInterval(intervalId);
  }else{
    counterFor++;
  }
}

var intervalId = setInterval(checkSubscription, 300);


$(document).on("change", '.rc-template__radio-group [type="radio"]', function(){
  let qty = parseInt($('.qty-container [name="qty"]').val());
  
  if($(this).val() == "onetime"){

    var checkVariant = $(".kaching-bundles__bar [type='radio']");

    checkVariant.each((i, el) => {
      if($(el).is(":checked")){
        checkVariant = $(el)
      }
    })

    var price = checkVariant.val() || $(this).next(".rc-radio__label").find(".price-label").text() || 0;
    price = parseFloat(price.replace("£",""));
    
    price = (price * qty).toFixed(2);

    if($(".product-info-price")){
      $(".product-info-price").text("£"+price);
    }
    
  }else{

    var checkVariant = $(".kaching-bundles__bar [type='radio']");
    
    checkVariant.each((i, el) => {
      if($(el).is(":checked")){
        checkVariant = $(el)
      }
    })

    var price = parseFloat(checkVariant.val());

    if(price){
      price = (price * qty).toFixed(2);
      
      save_percent = 10;
      price = (price - (price * (save_percent / 100))).toFixed(2);
      
    }else{
      price = $(this).next(".rc-radio__label").find(".price-label").text()
      price = parseFloat(price.replace("£",""));
      price = (price * qty).toFixed(2);
    }

      // console.log(price,">>>>>>>>>>>>>>>>>>>")
    if($(".product-info-price")){
      $(".product-info-price").text("£"+price);
    }
    
  }
})

let changePrice = 00;

$(".variants_pack .kaching-bundles__bar [type='radio']").on("change", function(){
  let qty = parseInt($('.qty-container [name="qty"]').val());
  
  if($(this).is(":checked")){
    
    var currentUrl = window.location.href;
    var urlSearchParams = new URLSearchParams(new URL(currentUrl).search);
    
    $(".product-info-price").removeClass("d-none");

    let total_price = parseFloat($(this).val());
    let id = $(this).attr("id");
    
    total_price = (total_price * qty).toFixed(2) || total_price;
    if (urlSearchParams.has('selling_plan')) {
      save_percent = 10;
    
      total_price = total_price - (total_price * (save_percent / 100));

    }
    
    let quantity = $(this).siblings(".kaching-bundles__bar-container").data("quantity");
    $("input[name='quantity']").val(qty);
    
    $(".form [name='id']").val(id);
    $(".form [name='id'").attr("data-productid" ,id);
    $(".form [name='product-id']").val(id);

    if (typeof total_price === "string") {
      total_price = parseFloat(total_price);
      total_price = total_price.toFixed(2);
    }
    
    changePrice = parseFloat(total_price).toFixed(2);
    
    $(".product-info-price").text("£"+changePrice);
  }
});


const intervalId2 = setInterval(checkForClass2, 200);
  
function checkForClass2() {
  
  const element = document.querySelector('.rc-checkbox__input');
  if (element) {
    
    let before_checked_pice = 00;
    $(".rc-checkbox__input").on("change", function(){
      let price = parseFloat(($(".product-info-price").text()).replace("£", ''));
      
      if($(this).is(":checked")){
        before_checked_pice = price;
        let discount = price - (price * .10);
        discount = discount.toFixed(2)
        $(".product-info-price").text("£"+discount);
      }else{
        // if(before_checked_pice !== 0){
        //   $(".product-info-price").text("£"+before_checked_pice);
        // }else{
        //   $(".product-info-price").text("£"+changePrice);
        // }
        // before_checked_pice = 00;

        if($('.variants_pack [type="radio"]').length){
          
          $('.variants_pack [type="radio"]').each(function() {
            if ($(this).is(":checked")) {
                var newQuantity = parseInt($(this).siblings("label").data("quantity"));
                var price = parseFloat($(this).val()); // Fixed syntax: $(this).val()
        
                $(".product-info-price").text("£" + price);
            }
          });
          
        }else{
          $(".product-info-price").text($('[name="product_price"]').val());
        }
        
      }
      
    })
    clearInterval(intervalId2);
  }
}


function openPopup2(event) {
  event.preventDefault();
    $('#popup_overlay').show();
    $('#finderModal2').show();
}

var appUrl2 = "https://fridgefiltershopfinder.com";

// var settings = {
//     "url": appUrl2 + "/api/quiz",
//     "method": "GET",
//     "timeout": 0,
//     "async": true,
//     "dataType": "JSON"
// };


// $.ajax(settings).done(function (response) {
//     displayBrands(response);
// });

// function displayBrands(brands){
//   let brands_html = `<option value="">Select your brand</option>`;
  
//   brands_html += brands.map(brand => {
//     return `<option value="${brand.id}">${brand.title}</option>`;
//   }).join(" ");

//   $("#dif-brand-selector").html(brands_html)
  
// }

$(".fridge_model_filter .button").on("click", function(e){
  var previousSelect = $(this).prev("select");

  document.querySelector("#dif-brand-selector")?.focus();
  
  // Check if the previous sibling is a <select> element
  if (previousSelect.length > 0) {
    // Focus on the <select> element to open its dropdown
    previousSelect.focus();
  }
});

let brand_name = "";
let tag = "";
$(".fridge_model_filter #dif-brand-selector").on("change", function(e){
  brand_name = $(this).val();

  if(brand_name){

    $(".step2.model_number").slideDown();

    if($('#dif-model-number').val()){
      displayProduct.call($('#dif-model-number')[0]);
    }
    
  }else{
    $('#dif-model-number').val("")
    $(".step2.model_number").slideUp()
    $(".fridge_model_filter .results").slideUp();
  }

  
});

// $(document).on("click", ".open_brand_modal", function(e){
//   closePopup_quiz();
//   setTimeout(openPopup,300);
// });
if($(".fridge_model_filter").length){
  var form = new FormData();
  form.append("id", $("#dif-model-number").attr('product_id'));
  
  var settings = {
      url: "https://fridgefiltershopfinder.com/api/has_model_filter",
      method: "POST",
      data: form,
      processData: false,
      contentType: false,
      dataType: "json",
  };
  
  $.ajax(settings)
      .done(function (response) {
          if (response && response.hasData) {
              $(".fridge_model_filter").hide();
          } else {
              $(".fridge_model_filter").show();
          }
      })
      .fail(function (xhr, status, error) {
          // Handle the case where the request fails
          console.error("Request failed:", status, error);
      });

}


let timer;

$('#dif-model-number').on("keyup", displayProduct);

$(document).on('click', function (e) {
    if (!$(e.target).closest('.suggestions_sku').length) {
        $('.suggestions_sku').addClass('d-none');
    }
});


function displayProduct(){
  
  clearTimeout(timer);

  if($(this).length && $(this).val()){
    tag = $(this).val();
  }else{
    tag = $('#dif-model-number').val();
  }
        
  $("#sticky-dif-model-number").val(tag);
  

    let product_id = $("#dif-model-number").attr('product_id');


  if(tag){

    timer = setTimeout(() => {
        var form = new FormData();
        form.append("tag", tag);
        form.append("brand_id", brand_name);
        form.append("product_id", product_id);

        var settings = {
           url: "https://fridgefiltershopfinder.com/api/model_number",
           method: "POST",
           data: form,
           processData: false,
           contentType: false,
           dataType: "json",
        };
        
        $.ajax(settings).done(function (response) {
          displayFiltered_Products(response, tag);
        });
    }, 250)
    
  }else{
    $(".suggestions_sku").addClass("d-none");
    $(".fridge_model_filter .results").slideUp();
    
  }
  
}

var model_products = [];
function displayFiltered_Products(products, model_inputed){
    
  if(Object.keys(products).length > 0){

    let product_id = $("#dif-model-number").attr('product_id');
// console.log(">>>>");
//     console.log(products);
// console.log(">>>>");
    
    // for (let skus in products) {
    //   let products2 = products[`${skus}`].products;
    //   if(!products2[`${product_id}`]){
    //     display_no();
    //     return;
    //   }
    // }
    

    let sku_html = "";

    const similarSkus = filterSkus(products, model_inputed);
    // console.log(similarSkus);

    if(similarSkus.products){
      model_products = similarSkus.products;
    }

    if(similarSkus.model_no.length > 0){
      $(".fridge_model_filter .results").slideUp();

      similarSkus.model_no.forEach(model => {
        sku_html += `<li>
          <a href="#" sku="${model}">${model}</a>
        </li>`;
      });
      
      $(".suggestions_sku").removeClass("d-none");
      $(".suggestions_sku ul").html(sku_html)
      
    }else{

      display_no();
      return;
    }
    
  }else{
    display_no();
  }
}

function filterSkus(skusArray, userInput) {
  const lowerUserInput = userInput.toLowerCase();
  const userInputLength = lowerUserInput.length;
  let model_no = [];
  let filteredSkus;

  for (let skus in skusArray) {
    let models = skusArray[`${skus}`].models;

    let filteredSkus2 = [];
    let models2 = [];
    if (typeof models === 'object' && models !== null) {
      models2 = Object.keys(models).map(function(key) {
        return models[key];
      });
    } else {
      models2 = models;
    }
    
    filteredSkus2 = models2.filter(sku => {
      const lowerSku = sku.toLowerCase();
      const truncatedSku = lowerSku.substring(0, userInputLength + 2); // Adjust the length here
      if (truncatedSku.includes(lowerUserInput)) {
        model_no.push(sku);
        filteredSkus = skusArray[`${skus}`].products;
      }
      return truncatedSku.includes(lowerUserInput);
    });
  }

  return { products: filteredSkus, model_no };
}


$(document).on("click", ".suggestions_sku ul a", function(event){

  event.preventDefault();
  event.stopPropagation();
  let get_sku = $(this).attr("sku");

  $("#dif-model-number").val(get_sku)
  
  if(Object.keys(model_products).length > 0){
    for (let product in model_products) {
      if(model_products[`${product}`].variants){
        showModel_result(model_products[`${product}`]);
        $(".suggestions_sku").addClass("d-none");
        break;
        return false;
      }
    }
  }
  // if(Object.keys(model_products).length > 0){
  //   for (let product in model_products) {
  //     if(model_products[`${product}`].variants){
        
  //       model_products[`${product}`].variants.forEach(variant => {
  //         if(variant.sku == get_sku || (variant.sku).toLowerCase() == (get_sku).toLowerCase()){
  //           $(".suggestions_sku").addClass("d-none");
  //           showModel_result(model_products[`${product}`])
  //         }
  //       })
        
  //     }
  //   }
  // }
  
  
})

function showModel_result(products){
  
  $(".fridge_model_filter .results").slideDown();
  if(!products.id){

    // openPopup()
    // $(".error_model_number").slideDown();
    // $(".fridge_model_filter .results").slideUp();

    var html = `<div class="compatible-product">
                    <span class="e-heading">
                      
                        <svg xmlns="http://www.w3.org/2000/svg" height="35" width="35" viewBox="0 0 512 512" fill="red">
                        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                        </svg>
                            
                          <h4>No</h4>
                      </span>

                      <p>This filter doesn't appear to fit your fridge.</p>
                      <button class="btn button" onclick="openPopup()" style="margin-top: 10px;">Click here and try our filter Finder</button>
                    </div>`

    $(".fridge_model_filter .results").html(html);
    
    // $(".error_model_number").text(`No matches were found for '${tag}'`);
    
  }else{

    var html = `<div class="compatible-product">
        <span class="e-heading">
          
            <svg xmlns="http://www.w3.org/2000/svg" height="35" width="35" viewBox="0 0 512 512" fill="#0244A9">
              <path d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM227.3 387.3l184-184c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0L216 308.1l-70.1-70.1c-6.2-6.2-16.4-6.2-22.6 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6l104 104c6.2 6.2 16.4 6.2 22.6 0z"></path>
            </svg>
                
            <h4>Yes</h4>
        </span>
                
        <p class="filtered_title">This filter fits your model number.</p>
                
        <a href="javascript::" onclick="openPopup()">If unsure, Click here and try our filter finder</a>
        <div class="add-to-basket">
            <a href="/products/${products.handle}" class="btn button shoppingCartTrack">Buy Now &gt;</a>
        </div>
    </div>`

    $(".fridge_model_filter .results").html(html);

    // $(".filtered_title span").text(products.title);
    // $(".button.shoppingCartTrack").attr("href", "/products/"+ products.handle);

    // $(".fridge_model_no .product_lists").html(html);
    
  }
}


function display_no(){
  $(".suggestions_sku").addClass("d-none");
  showModel_result({});
  return;
}


// var productDetails = $(".product_details .product-info");

// $(window).on("scroll", function() {
//   var windowScrollTop = $(window).scrollTop();
//   var elementOffset = productDetails.offset().top;
//   var elementHeight = productDetails.height();
//   var isSmallDevice = window.innerWidth < 767;

//   if (isSmallDevice) {
//     $("#sticky-product-fit").addClass("d-none");
//     return;
//   }else{
//     $("#sticky-product-fit").removeClass("d-none");
//   }

//   if (windowScrollTop >= elementOffset && windowScrollTop <= elementOffset + elementHeight) {
//     $("#sticky-product-fit").slideDown(400, function() {
//       $(this).css("display", "flex");
//     });
//   } else {
//     $("#sticky-product-fit").slideUp();
//   }
// });


$("#sticky-dif-model-number").on("keyup", function() {
  
  $("#dif-model-number").val($(this).val());
  $("#dif-model-number").trigger("keyup");
  
  $("html, body").animate({
    scrollTop: $(".fridge_model_filter").offset().top
  }, 1000);
  
  setTimeout(() => {
    $("#sticky-product-fit").slideDown()
  }, 1100)
});

$('[href="#how-to-find-model-number"]').on("click", function(){
  $("#how-to-find-model-number").slideToggle();
})

var animationTimeout;

$(".pos-next").on("click", function(){
  // clearTimeout(animationTimeout);
  // $(".pos-start").trigger("click");
  $(".position-image").animate({
    'background-position-x': '-162px'
  });
});

$(".pos-prev").on("click", function(){
  // clearTimeout(animationTimeout);
  // $(".pos-start").trigger("click");
  $(".position-image").animate({
    'background-position-x': '0'
  });
});

$(".pos-start").on("click", function(){
  // $(".pos-stop").show();
  // $(".pos-start").hide();

  clearTimeout(animationTimeout);
  // Start the animation after a delay of 1 second
  animationTimeout = setTimeout(animateBackground, 1000);
});

$(".pos-stop").on("click", function(){
  // $(".pos-start").show();
  // $(".pos-stop").hide();

  // Clear the animation timeout
  clearTimeout(animationTimeout);
});

function animateBackground() {
  $(".position-image").animate({
    'background-position-x': '-162px'
  }, 300, function() {
    $(".position-image").css('background-position-x', '0');
    // Call the function recursively after a delay of 1 second
    animationTimeout = setTimeout(animateBackground, 1000);
  });
}


var buttonPlus  = $(".qty-btn-plus");
var buttonMinus = $(".qty-btn-minus");

var incrementPlus = buttonPlus.click(function() {
  var $n = $(this)
  .parent(".qty-container")
  .find(".input-qty");
  $n.val(Number($n.val())+1 );
});

var incrementMinus = buttonMinus.click(function() {
  var $n = $(this)
  .parent(".qty-container")
  .find(".input-qty");
  var amount = Number($n.val());
  if (amount > 1) {
    $n.val(amount-1);
  }
});


$(".qty-container button").on("click", function(){

  // if($(this).attr("action") == "minus"){

    var checkVariant = $(".kaching-bundles__bar [type='radio']");

    checkVariant.each((i, el) => {
      if($(el).is(":checked")){
        checkVariant = $(el)
      }
    })
  
    var price = $(checkVariant).val();

    price = price.replace("£", "");
    price = parseFloat(price);

    var currentUrl = window.location.href;
    var urlSearchParams = new URLSearchParams(new URL(currentUrl).search);

    if (urlSearchParams.has('selling_plan')) {
      price = price - (price * (10 / 100));
    }

    let qty = parseInt($('.qty-container [name="qty"]').val());

    let final = price;

    // if($(this).attr("action") == "minus"){
    //   final = (price / qty).toFixed(2);
    // }else{
      final = (price * qty).toFixed(2);
    // }

    
  // console.log(final, price, qty)
    $(".product-info-main .product-info-price").text("£"+ final)
    
  // }
  
})

$(document).on("click", '.shoppingCartTrack', function(e){

  e.preventDefault();

  $(".qty-container .input-qty").val(1);
  $('.kaching-bundles__bar input[type="radio"]:checked').click(); // Corrected selector
  $('.product-actions-add-to-cart button').click();

  closePopup_quiz();
  
});

